// ไฟล์: frontend/src/pages/InnovationsPage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './ResourcesPage.css'; // ใช้ CSS เดียวกับ ResourcesPage

const InnovationsPage = () => {
  const [innovations, setInnovations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [gradeLevels, setGradeLevels] = useState([]);
  const [loading, setLoading] = useState(true);

  // ฟิลเตอร์
  const [filters, setFilters] = useState({
    category: '',
    subject: '',
    gradeLevel: '',
    sortBy: 'newest'
  });

  // สำหรับการแสดงจำนวน
  const [visibleCount, setVisibleCount] = useState(12);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [innovationsRes, categoriesRes, subjectsRes, gradeLevelsRes] = await Promise.all([
          axios.get('/innovations'),
          axios.get('/categories'),
          axios.get('/subjects'),
          axios.get('/grade-levels')
        ]);

        setInnovations(innovationsRes.data.innovations);
        setCategories(categoriesRes.data.categories);
        setSubjects(subjectsRes.data.subjects);
        setGradeLevels(gradeLevelsRes.data.gradeLevels);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // ฟังก์ชันจัดการการเปลี่ยนแปลงฟิลเตอร์
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value
    }));
  };

  // ฟังก์ชันรีเซ็ตฟิลเตอร์
  const resetFilters = () => {
    setFilters({
      category: '',
      subject: '',
      gradeLevel: '',
      sortBy: 'newest'
    });
  };

  // กรองและเรียงลำดับนวัตกรรม
  const filteredInnovations = innovations.filter(innovation => {
    let matchesCategory = true;
    let matchesSubject = true;
    let matchesGradeLevel = true;

    if (filters.category) {
      matchesCategory = innovation.category_id === parseInt(filters.category);
    }

    if (filters.subject) {
      matchesSubject = innovation.subject_id === parseInt(filters.subject);
    }

    if (filters.gradeLevel) {
      matchesGradeLevel = innovation.grade_level_id === parseInt(filters.gradeLevel);
    }

    return matchesCategory && matchesSubject && matchesGradeLevel;
  }).sort((a, b) => {
    switch (filters.sortBy) {
      case 'newest':
        return new Date(b.created_at) - new Date(a.created_at);
      case 'oldest':
        return new Date(a.created_at) - new Date(b.created_at);
      case 'popular':
        return b.view_count - a.view_count;
      case 'rating':
        return (b.avg_rating || 0) - (a.avg_rating || 0);
      default:
        return new Date(b.created_at) - new Date(a.created_at);
    }
  });

  // แสดงเพิ่มเติม
  const loadMore = () => {
    setVisibleCount(prevCount => prevCount + 12);
  };

  // แสดงสถานะการโหลด
  if (loading) {
    return (
      <div className="loading-container">
        {/* <div className="loading-spinner">กำลังโหลดข้อมูล...</div> */}
      </div>
    );
  }

  return (
    <div className="innovations-page">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">
            <i className="fas fa-lightbulb"></i> นวัตกรรมการศึกษา
          </h1>
          <div className="page-actions">
            <Link to="/upload-innovation" className="btn btn-primary">
              <i className="fas fa-plus"></i> แชร์นวัตกรรม
            </Link>
          </div>
        </div>

        {/* Filters */}
        <div className="filters-section">
          <div className="filters-container">
            <div className="filter-group">
              <label htmlFor="category">หมวดหมู่</label>
              <select 
                id="category" 
                name="category" 
                value={filters.category} 
                onChange={handleFilterChange}
                className="form-select"
              >
                <option value="">ทั้งหมด</option>
                {categories.map(category => (
                  <option key={category.id} value={category.id}>{category.name}</option>
                ))}
              </select>
            </div>
            <div className="filter-group">
              <label htmlFor="subject">วิชา</label>
              <select 
                id="subject" 
                name="subject" 
                value={filters.subject} 
                onChange={handleFilterChange}
                className="form-select"
              >
                <option value="">ทั้งหมด</option>
                {subjects.map(subject => (
                  <option key={subject.id} value={subject.id}>{subject.name}</option>
                ))}
              </select>
            </div>
            <div className="filter-group">
              <label htmlFor="gradeLevel">ระดับชั้น</label>
              <select 
                id="gradeLevel" 
                name="gradeLevel" 
                value={filters.gradeLevel} 
                onChange={handleFilterChange}
                className="form-select"
              >
                <option value="">ทั้งหมด</option>
                {gradeLevels.map(gradeLevel => (
                  <option key={gradeLevel.id} value={gradeLevel.id}>{gradeLevel.name}</option>
                ))}
              </select>
            </div>
            <div className="filter-group">
              <label htmlFor="sortBy">เรียงลำดับ</label>
              <select 
                id="sortBy" 
                name="sortBy" 
                value={filters.sortBy} 
                onChange={handleFilterChange}
                className="form-select"
              >
                <option value="newest">ล่าสุด</option>
                <option value="oldest">เก่าสุด</option>
                <option value="popular">ยอดเข้าชม</option>
                <option value="rating">คะแนน</option>
              </select>
            </div>
            <div className="filter-actions">
              <button onClick={resetFilters} className="btn btn-light">
                <i className="fas fa-sync-alt"></i> รีเซ็ต
              </button>
            </div>
          </div>
        </div>

        {/* Results */}
        <div className="results-section">
          <div className="results-header">
            <h2>นวัตกรรมทั้งหมด ({filteredInnovations.length})</h2>
          </div>

          {filteredInnovations.length > 0 ? (
            <>
              <div className="resources-grid">
                {filteredInnovations.slice(0, visibleCount).map(innovation => (
                  <div className="resource-card" key={innovation.id}>
                    <div className="resource-thumbnail">
                      <img 
                        src={innovation.thumbnail 
                          ? `${process.env.REACT_APP_API_URL}/uploads/${innovation.thumbnail}`
                          : '/assets/default-innovation.jpg'} 
                        alt={innovation.title} 
                      />
                      <span className="resource-type">นวัตกรรม</span>
                    </div>
                    <div className="resource-content">
                      <h3 className="resource-title">
                        <Link to={`/innovations/${innovation.id}`}>{innovation.title}</Link>
                      </h3>
                      <div className="resource-tags">
                        <span className="resource-tag">{innovation.subject_name}</span>
                        <span className="resource-tag">{innovation.grade_level_name}</span>
                      </div>
                      <div className="resource-description">
                        {innovation.description?.length > 100
                          ? `${innovation.description.substring(0, 100)}...`
                          : innovation.description}
                      </div>
                      <div className="resource-meta">
                        <div className="resource-author">
                          <img 
                            src={innovation.author_image 
                              ? `${process.env.REACT_APP_API_URL}/uploads/profiles/${innovation.author_image}`
                              : `https://ui-avatars.com/api/?name=${innovation.author_name}&background=random`} 
                            alt={innovation.author_name} 
                          />
                          <span>{innovation.author_name}</span>
                        </div>
                        <div className="resource-stats">
                          <div className="resource-views">
                            <i className="fas fa-eye"></i> {innovation.view_count}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="resource-footer">
                      <div className="resource-rating">
                        <div className="rating">
                          {[1, 2, 3, 4, 5].map(star => (
                            <i 
                              key={star}
                              className={`fas fa-star ${star <= Math.round(innovation.avg_rating || 0) ? 'filled' : ''}`}
                            ></i>
                          ))}
                        <span className="rating-value">
                          {innovation.avg_rating !== undefined &&
                           innovation.avg_rating !== null &&
                           !isNaN(Number(innovation.avg_rating))
                            ? Number(innovation.avg_rating).toFixed(1)
                            : '0.0'}
                        </span>                        </div>
                      </div>
                      <Link to={`/innovations/${innovation.id}`} className="btn btn-sm btn-primary">
                        <i className="fas fa-info-circle"></i> รายละเอียด
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
              
              {visibleCount < filteredInnovations.length && (
                <div className="load-more">
                  <button onClick={loadMore} className="btn btn-primary">
                    <i className="fas fa-plus"></i> แสดงเพิ่มเติม
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="empty-state">
              <div className="empty-state-icon">
                <i className="fas fa-search"></i>
              </div>
              <h3>ไม่พบนวัตกรรมที่ตรงกับเงื่อนไข</h3>
              <p>ลองเปลี่ยนเงื่อนไขการค้นหาหรือรีเซ็ตตัวกรอง</p>
              <button onClick={resetFilters} className="btn btn-primary">
                <i className="fas fa-sync-alt"></i> รีเซ็ตตัวกรอง
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InnovationsPage;
